import { get, internalDestroy, internalPost, internalPut } from '.';
import qs from 'qs';

export const getBedTypes = ({ filters }) => {
  return get(`/beds?${qs.stringify(filters)}`);
};

export const getBedType = ({ bedTypeId, locale }) => {
  return get(`/beds/${bedTypeId}?locale=${locale}`);
};

export const createBedType = ({ payload, locale }) => {
  return internalPost(`/beds?${qs.stringify(locale)}`, payload);
};

export const updateBedType = ({ bedTypeId, payload, locale }) => {
  return internalPut(`/beds/${bedTypeId}?locale=${locale}`, payload);
};

export const deleteBedType = ({ bedTypeId, payload }) => {
  return internalDestroy(`/beds/${bedTypeId}`, payload);
};
